module.exports = __webpack_public_path__ + "static/media/rocket.d086a142.png";